import { Camera, MessagesSquare, Video } from 'lucide-react'
import { Link } from 'react-router-dom'
import { NAV_ITEMS, SITE } from '../config/site'

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container site-footer__grid">
        <div className="site-footer__identity">
          <p className="site-footer__kicker">Une communauté, une parole, une mission.</p>
          <h2>{SITE.name}</h2>
          <p>Grandir dans la foi, servir avec intégrité et faire rayonner l’Évangile au cœur de Brazzaville.</p>
        </div>

        <div>
          <h3>Navigation</h3>
          <ul className="footer-links">
            {NAV_ITEMS.map((item) => (
              <li key={item.to}><Link to={item.to}>{item.label}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h3>Nous trouver</h3>
          <address>
            <span>{SITE.location}</span>
            <a href={`tel:${SITE.phoneHref}`}>{SITE.phone}</a>
            <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
          </address>
          <div className="social-links" aria-label="Réseaux sociaux">
            <a href={SITE.social.facebook} target="_blank" rel="noreferrer" aria-label="Facebook"><MessagesSquare size={21} strokeWidth={1.7} /></a>
            <a href={SITE.social.youtube} target="_blank" rel="noreferrer" aria-label="YouTube"><Video size={22} strokeWidth={1.7} /></a>
            <a href={SITE.social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram"><Camera size={21} strokeWidth={1.7} /></a>
          </div>
        </div>
      </div>
      <div className="container site-footer__bottom">
        <span>© {new Date().getFullYear()} {SITE.name}</span>
        <span>www.royaumedesacrificateurs.com</span>
      </div>
    </footer>
  )
}
